/**
 * Flow Configuration Data (Lightweight)
 *
 * This file contains ONLY the data portion of flow configurations - no React
 * components or UI imports. This allows other modules to access flow metadata
 * without pulling in the full UI bundle.
 *
 * IMPORTANT: Keep this file free of React imports and UI components.
 * If you need React nodes, they belong in flow-configs.tsx.
 */

import { OnboardingFlow } from '@mondaygpt/constants'

/**
 * Data-only configuration for each flow.
 * These are the non-UI properties that can be safely imported anywhere.
 */
export interface FlowConfigData {
  /** Flow identifier */
  id: OnboardingFlow

  /** Landing page path (for documentation/reference) */
  landingPagePath: string | null

  /** Whether this flow handles business creation internally */
  internalBusinessCreation: boolean
}

/**
 * Registry of flow configuration data.
 * This is the single source of truth for flow metadata.
 */
export const FLOW_CONFIG_DATA: Record<OnboardingFlow, FlowConfigData> = {
  [OnboardingFlow.Default]: {
    id: OnboardingFlow.Default,
    landingPagePath: null,
    internalBusinessCreation: true,
  },
  [OnboardingFlow.Social]: {
    id: OnboardingFlow.Social,
    landingPagePath: '/lp/social',
    internalBusinessCreation: true,
  },
}

/**
 * Flows that handle business creation internally.
 * Derived from FLOW_CONFIG_DATA to maintain single source of truth.
 */
export const FLOWS_WITH_INTERNAL_BUSINESS_CREATION: OnboardingFlow[] = Object.values(
  FLOW_CONFIG_DATA
)
  .filter(config => config.internalBusinessCreation)
  .map(config => config.id)
